/**
 * @param {URLSearchParams} searchParams
 * @param {string} urlStateKey
 */
export function clearPrefixedParams(searchParams, urlStateKey) {
  const prefix = `${urlStateKey}.`;
  const keysToDelete = [];
  for (const key of searchParams.keys()) {
    if (key.startsWith(prefix)) {
      keysToDelete.push(key);
    }
  }
  for (const key of keysToDelete) {
    searchParams.delete(key);
  }
}

/**
 * @param {URLSearchParams} searchParams
 * @param {string} urlStateKey
 * @returns {Record<string, string>}
 */
export function getPrefixedParams(searchParams, urlStateKey) {
  /** @type {Record<string, string>} */
  const params = {};
  const prefix = `${urlStateKey}.`;
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith(prefix)) {
      params[key] = value;
    }
  }
  return params;
}

/**
 * @param {Record<string, string>} left
 * @param {Record<string, string>} right
 * @returns {boolean}
 */
export function areParamRecordsEqual(left, right) {
  const leftKeys = Object.keys(left).sort();
  const rightKeys = Object.keys(right).sort();
  if (leftKeys.length !== rightKeys.length) {
    return false;
  }
  return leftKeys.every((key, index) => key === rightKeys[index] && left[key] === right[key]);
}

export {
  buildPrefixedKey,
  escapeFilterValue,
  unescapeFilterValue,
  splitFilterValueOperator,
  parseGridUrlState,
  serializeGridUrlState,
  isColumnVisible,
  isColumnVisibleByDefault,
} from "./dataGridUrlStateCodec.js";
